import Dashboard from "pages/Dashboard.js";
import Lucky77 from "pages/Lucky77";
import TeenPatti from "pages/TeenPatti";
import Aladin from "pages/Aladin";
import Greedy from "pages/Greedy";
import Roulette from "pages/Roulette";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/teen-patti",
    name: "Teen Patti",
    icon: "nc-icon nc-controller-modern",
    component: TeenPatti,
    layout: "/admin",
  },
  {
    path: "/lucky77",
    name: "Lucky 77",
    icon: "nc-icon nc-controller-modern",
    component: Lucky77,
    layout: "/admin",
  },
  {
    path: "/greedy",
    name: "Greedy",
    icon: "nc-icon nc-controller-modern",
    component: Greedy,
    layout: "/admin",
  },
  {
    path: "/aladin",
    name: "Aladin",
    icon: "nc-icon nc-controller-modern",
    component: Aladin,
    layout: "/admin",
  },
  {
    path: "/roulette",
    name: "Roulette",
    icon: "nc-icon nc-controller-modern",
    component: Roulette,
    layout: "/admin",
  },

  // {
  //   path: "/users",
  //   name: "Users",
  //   icon: "nc-icon nc-single-02",
  //   component: Users,
  //   layout: "/admin",
  // },
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "nc-icon nc-circle-09",
  //   component: UserProfile,
  //   layout: "/admin",
  // },
  // {
  //   path: "/table",
  //   name: "Table List",
  //   icon: "nc-icon nc-notes",
  //   component: TableList,
  //   layout: "/admin",
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   icon: "nc-icon nc-paper-2",
  //   component: Typography,
  //   layout: "/admin",
  // },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "nc-icon nc-atom",
  //   component: Icons,
  //   layout: "/admin",
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "nc-icon nc-pin-3",
  //   component: Maps,
  //   layout: "/admin",
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   icon: "nc-icon nc-bell-55",
  //   component: Notifications,
  //   layout: "/admin",
  // },
];

export default dashboardRoutes;
